// src/utils/api.js
import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
});

// Injecter le token JWT
api.interceptors.request.use(config => {
  const token = localStorage.getItem('fl_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Gestion erreurs globale
api.interceptors.response.use(
  res => res,
  async err => {
    const msg = err.response?.data?.message;
    if (err.response?.status === 401 && err.response?.data?.expired) {
      // Tenter refresh token
      const refreshToken = localStorage.getItem('fl_refresh');
      if (refreshToken) {
        try {
          const { data } = await axios.post('/api/auth/refresh', { refreshToken });
          localStorage.setItem('fl_token', data.accessToken);
          err.config.headers.Authorization = `Bearer ${data.accessToken}`;
          return api(err.config);
        } catch {
          localStorage.clear();
          window.location.href = '/connexion';
        }
      }
    }
    if (err.response?.status === 403) toast.error('Accès non autorisé');
    if (err.response?.status === 429) toast.error('Trop de requêtes, veuillez patienter');
    if (err.response?.status >= 500) toast.error('Erreur serveur, réessayez');
    return Promise.reject(err);
  }
);

export default api;
